"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NoOpVideoElementFactory = /*#__PURE__*/function () {
  function NoOpVideoElementFactory() {
    _classCallCheck(this, NoOpVideoElementFactory);
  }

  _createClass(NoOpVideoElementFactory, [{
    key: "create",
    value: function create() {
      var element = {
        clientWidth: 400,
        clientHeight: 300,
        width: 400,
        height: 300,
        videoWidth: 400,
        videoHeight: 300,
        style: {
          transform: ''
        },
        hasAttribute: function hasAttribute() {
          return false;
        },
        removeAttribute: function removeAttribute() {},
        setAttribute: function setAttribute() {},
        srcObject: false,
        pause: function pause() {},
        play: function play() {
          return Promise.resolve();
        }
      }; // @ts-ignore

      return element;
    }
  }]);

  return NoOpVideoElementFactory;
}();

exports.default = NoOpVideoElementFactory;